module.exports = "/static/assets/f90e5c595227d39d84dd5be2e317ee54.svg";